export default __webpack_public_path__ + "static/media/calendarIcon.79eb43d6.svg";